import React, { forwardRef, useImperativeHandle, useState } from "react";

export default forwardRef((props, ref) => {
  // eslint-disable-next-line
  const [data, setData] = useState(
    props.api.getDisplayedRowAtIndex(props.rowIndex).data
  );

  useImperativeHandle(ref, () => {
    return {
      getReactContainerClasses() {
        return ["custom-tooltip"];
      },
    };
  });

  return (
    <div
      className="custom-tooltip"
      style={{ backgroundColor: props.color || "white" }}
    >
      <p>
        <span>
          {data.civilite} {data.nom} {data.prenom}
        </span>
      </p>
      <p>
        <span>Date de naissance: </span>{" "}
        {data.date_naissance ? data.date_naissance : null}
      </p>
      <p>
        <span>Mutuelle: </span> {data.nom_mutuelle}
      </p>
      <p>
        <span>CIN: </span> {data.cin}
      </p>
      <p>
        <span>Date de creation: </span>{" "}
        {data.date_creation ? data.date_creation : null}
      </p>
      <p>
        <span>Date de modification: </span>{" "}
        {data.date_de_modification ? data.date_de_modification : null}
      </p>
    </div>
  );
});
